// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTagsOutlinedSvg from "@fishx/icons-svg/es/asn/PTagsOutlined";
import FishxIcon from '../components/FishxIcon';

var PTagsOutlined = function PTagsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTagsOutlinedSvg
  }));
};

PTagsOutlined.displayName = 'PTagsOutlined';
export default React.forwardRef(PTagsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTagsOutlined.js
// module id = 3682
// module chunks = 0